import { Component } from '@angular/core';
import { ParagraphDirective } from '../../shared/directives/paragraph.directive';
import { RouterLink } from '@angular/router';
import { StandardButtonDirective } from '../../shared/directives/standard-button.directive';
import { CommonModule } from '@angular/common';
import { LinkButtonDirective } from '../../shared/directives/link-button.directive';
import { CmsTextPipe } from '../../pipes/cms-text.pipe';

@Component({
  selector: 'app-outdated-test',
  standalone: true,
  imports: [CommonModule, RouterLink, ParagraphDirective, StandardButtonDirective, LinkButtonDirective, CmsTextPipe],
  templateUrl: './outdated-test.component.html',
  styleUrl: './outdated-test.component.scss'
})
export class OutdatedTestComponent {

}
